import styled from 'styled-components'

export const Container = styled.button`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: 6px 12px;
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.secondary};
  cursor: pointer;
  min-width: 200px;

  &:hover {
    border-color: ${props => props.theme.colors.border.default};
    background-color: ${props => props.theme.colors.disabled.surface};
  }
`

export const Placeholder = styled.span`
  flex: 1;
  text-align: left;
  font-size: 13px;
  color: ${props => props.theme.colors.text.subtle};
`

export const Shortcut = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
